<template>
  <v-dialog v-model="dialog" width="500">
    <template v-slot:activator="{ on, attrs }">
      <v-btn color="success" large v-bind="attrs" v-on="on"
        >Leverera

        <v-icon right dark>
          mdi-send
        </v-icon>
      </v-btn>
    </template>

    <v-card>
      <div class="px-4 py-4 text-center green darken-2">
        <h1 class="text-h4 white--text">Leverera Order {{ order.orderId }}</h1>
      </div>

      <v-container>
        <v-simple-table>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">
                  Vara
                </th>
                <th class="text-left">
                  Antal
                </th>
                <th class="text-left">
                  Enhet
                </th>
                <th class="text-left">
                  pris
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in order.items" :key="item.id">
                <td>{{ item.title }}</td>
                <td>{{ item.quantity }}</td>
                <td>{{ item.unit }}</td>
                <td>{{ item.price }} kr/{{ item.unit }}</td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>

        <v-divider></v-divider>

        <v-row>
          <v-col class="text-center mt-4">
            Är du helt säker på att du vill <strong>Leverera</strong> order
            {{ order.orderId }}
          </v-col>
        </v-row>
      </v-container>

      <v-divider></v-divider>

      <v-card-actions>
        <v-btn color="primary" text @click.prevent="onCancel" outlined>
          Stäng
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn color="success" text @click.prevent="onConfirm" outlined>
          Leverera
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { deliverOrder } from "../../firebase/orders";

export default {
  props: {
    order: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      dialog: false
    };
  },
  methods: {
    async onConfirm() {
      await deliverOrder(this.order.orderId);
      this.dialog = false;
    },
    onCancel() {
      this.dialog = false;
    }
  }
};
</script>
